import { concatURI } from '../utils/common';
import { config } from '../config/constants';
import { getState } from './state';
import { WechatState } from './wechat';
const img = new Image();
img.crossOrigin = 'Anonymous';
/**
* 提交一个错误日志
* @description 记录的错误包括app内部错误（通过spa框架的钩子捕获）/UnhandledRejection/GlobalError
* 日志会提交至阿里云
* @param {*} [app]
* @param {boolean} catchWindow 捕获window.event `unhandledrejection`和`error`
*/
export function emitErrorLog(app, catchWindow = true) {
    // app error
    if (app) {
        app.config.errorHandler = (err, _vm, info) => {
            reportError(err, info);
        };
    }
    if (catchWindow) {
        // UnhandledRejection
        window.addEventListener('unhandledrejection', (ev) => {
            var _a;
            const message = typeof ev.reason === 'string' ? ev.reason : (_a = ev.reason) === null || _a === void 0 ? void 0 : _a.message;
            reportError({ name: 'UnhandledRejection', message });
        });
        // GlobalError
        window.addEventListener('error', (ev) => {
            reportError({ name: 'GlobalError', message: ev.message });
        });
    }
}
const lastModified = document.lastModified;
/**
 * 提交日志至阿里云
 * @description 同时会带上当前路径/uaId/openid(存在的话)
 * @param {Error} err
 * @param {string} [info] 错误信息
 */
export function reportLog(err, info) {
    var _a;
    if (!config.errorSession)
        return;
    img.src = concatURI(`https://web-tracking-site-log.cn-hangzhou.log.aliyuncs.com/logstores/${config.errorSession}/track_ua.gif?APIVersion=0.6.0&__topic__=error`, {
        href: window.location.href,
        uaId: config.uaId,
        openid: (_a = getState(WechatState)) === null || _a === void 0 ? void 0 : _a.openid,
        name: err.name,
        message: err.message,
        lastModified,
        info
    });
}
/**
 * 上报错误日志
 * @description 同时会带上当前路径/uaId/openid(存在的话)
 * @param {Error} err
 * @param {string} [info] 错误信息
 */
export function reportError(err, info) {
    console.error(err.message);
    reportLog(err, info);
}
/**
 * 上报分析
 * @param {Record<string, string>} pkg
 */
export function reportAnalysize(pkg) {
    reportLog({ name: 'analysize', message: 'package' }, JSON.stringify(pkg));
}
